<div class="freida-v2 bg-light-grey home">
  <app-hero-search
    [suggestedProgramTitle]="suggestedProgramTitle()"
    [suggestedPrograms]="suggestedPrograms()"
    [isLoading]="homeLoading()"
    [selectedProgramType]="selectedProgramType()"
    [programTypeOptions]="programTypeOptions"
    (selectedProgramTypeChange)="onProgramTypeChange($event)"
  />

  @if (homeLoading()) {
    <section class="home__content-section home__skeleton-section" aria-hidden="true">
      <div class="layout-container">
        <div class="home__skeleton-grid">
          <div class="home__skeleton-image"></div>
          <div class="home__skeleton-text">
            <div class="home__skeleton-bar home__skeleton-bar--badge"></div>
            <div class="home__skeleton-bar home__skeleton-bar--heading"></div>
            <div class="home__skeleton-bar home__skeleton-bar--heading home__skeleton-bar--heading-short"></div>
            <div class="home__skeleton-bar home__skeleton-bar--body"></div>
            <div class="home__skeleton-bar home__skeleton-bar--body"></div>
            <div class="home__skeleton-bar home__skeleton-bar--body home__skeleton-bar--body-short"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="home__benefits-section home__skeleton-section" aria-hidden="true">
      <div class="layout-container">
        <div class="home__skeleton-cards">
          @for (i of skeletonCardIndices; track i) {
            <div class="home__skeleton-card">
              <div class="home__skeleton-card-icon"></div>
              <div class="home__skeleton-card-body">
                <div class="home__skeleton-bar home__skeleton-bar--card-title"></div>
                <div class="home__skeleton-bar home__skeleton-bar--body"></div>
                <div class="home__skeleton-bar home__skeleton-bar--body home__skeleton-bar--body-short"></div>
              </div>
            </div>
          }
        </div>
      </div>
    </section>
  } @else {
    @if (contentBlockData(); as content) {
      <section class="home__content-section">
        <app-content-block
          [label]="content.label"
          [heading]="content.title"
          [description]="content.body_copy"
          [imageUrl]="$safeNavigationMigration(content.image?.media_image?.url)"
          [imageAlt]="content.image?.media_image?.alt || ''"
          [labelColor]="'purple'"
        />
      </section>
    }

    @if (cards().length > 0) {
      <section class="home__benefits-section">
        <app-benefit-card [cards]="cards()" />
      </section>
    }
  }

  @if (membershipBenefits(); as mb) {
    <section class="home__membership-table-section">
      <app-membership-table
        [heading]="mb.heading"
        [description]="mb.description"
        [membership]="mb"
      />
    </section>
  }
</div>
